export function setPackages(data) {
  return { type: "SET_PACKAGES", data };
}

export function setPackageDetail(data) {
  return { type: "SET_PACKAGE_DETAIL", data };
}
